import { RMH, JobType, Brand, Crop, Language, FinalRequirementFilters, jobNumber, State } from "../MCPlanningMaterial/mcplanningmaterial"
export class productionFilter extends FinalRequirementFilters
 {
    rmhs: RMH[];
    jobTypes: JobType[];
    brands: Brand[];
    crops: Crop[];
    languages: Language[];
    Month: any[];
    jobNumbers:jobNumber[];
    states:State[];
    vendor:vendor[];
    currentRequirementYear: CurrentRequirementYear[];
}
export class productionDetails {  
    requirementDetailsID:any;
    jobNumber:string;
    rmhName:string;
    rmhid:string;
    jobType:string;
    brand:string;
    brandID:string;
    cropName:string;
    cropID:string;
    Language:string;
    LanguageID:string;
    state:string;
    stateCode:string;
    month:string
    approvedQuantity:any;
    status:any;
    isSelected:boolean=false;
    requirementType:number;
    vendorType:string;
}
export class ProductionStatus
{
    StatusID:number;
    StatusName:string;
}
export class vendor
{
    vendorId:number;
    vendorType:string;
}

export class productionDetails_ByPoNumer
{
    jobNumber:string;
    poNumber:string;
    approvedQuantity:string;
    rmhName:string;
}

export class CurrentRequirementYear{
    year: string;
    currentrequirementYear: string;
}
